import routerOptions0 from "D:/tjtw/edu/education-web/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}